import { render, staticRenderFns } from "./IndoorTrack.vue?vue&type=template&id=5960dfc6&scoped=true&"
import script from "./IndoorTrack.vue?vue&type=script&lang=js&"
export * from "./IndoorTrack.vue?vue&type=script&lang=js&"
import style0 from "./IndoorTrack.vue?vue&type=style&index=0&id=5960dfc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960dfc6",
  null
  
)

component.options.__file = "IndoorTrack.vue"
export default component.exports